import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, Input, message, Result, Spin } from 'antd';
import { CheckCircleOutlined, EditOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import SignaturePad from 'signature_pad';
import api from '../services/api';

export default function Assinar() {
  const { token } = useParams();
  const [proposta, setProposta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [nome, setNome] = useState('');
  const [modo, setModo] = useState('desenhar');
  const [assinando, setAssinando] = useState(false);
  const [assinado, setAssinado] = useState(false);
  const [erro, setErro] = useState('');
  // O link do cliente e igual para os dois tipos de proposta; o prefixo
  // certo e descoberto no carregamento.
  const [prefixo, setPrefixo] = useState('/assinatura/token/');
  const canvasRef = useRef(null);
  const padRef = useRef(null);

  useEffect(() => { carregar(); }, [token]);

  useEffect(() => {
    if (modo === 'desenhar' && canvasRef.current && proposta) {
      setTimeout(() => {
        if (canvasRef.current) {
          padRef.current = new SignaturePad(canvasRef.current, { backgroundColor: 'rgb(255,255,255)', penColor: 'rgb(0,0,0)' });
          const canvas = canvasRef.current;
          const ratio = Math.max(window.devicePixelRatio || 1, 1);
          canvas.width = canvas.offsetWidth * ratio;
          canvas.height = canvas.offsetHeight * ratio;
          canvas.getContext('2d').scale(ratio, ratio);
          padRef.current.clear();
        }
      }, 300);
    }
  }, [modo, proposta]);

  const carregar = async () => {
    try {
      let r, pref = '/assinatura/token/';
      try {
        r = await api.get(pref + token);
      } catch (e1) {
        pref = '/assinatura/produto/token/';
        r = await api.get(pref + token);
      }
      setPrefixo(pref);
      setProposta(r.data);
      if (r.data.assinatura_cliente) setAssinado(true);
    } catch(e) { setErro('Link inválido ou expirado.'); }
    finally { setLoading(false); }
  };

  const assinar = async () => {
    if (!nome.trim()) { message.warning('Digite seu nome completo'); return; }
    let assinatura = '';
    if (modo === 'digitar') {
      const canvas = document.createElement('canvas');
      canvas.width = 600; canvas.height = 120;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, 600, 120);
      // Ajustar fonte conforme tamanho do nome
      let fontSize = 52;
      ctx.font = fontSize + 'px Dancing Script, cursive';
      while (ctx.measureText(nome).width > 560 && fontSize > 20) {
        fontSize -= 2;
        ctx.font = fontSize + 'px Dancing Script, cursive';
      }
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      ctx.fillText(nome, 300, 85);
      assinatura = canvas.toDataURL('image/png');
    } else {
      if (!padRef.current || padRef.current.isEmpty()) { message.warning('Faça sua assinatura'); return; }
      assinatura = padRef.current.toDataURL('image/png');
    }
    setAssinando(true);
    try {
      await api.post(prefixo + token + '/cliente', { assinatura, nome });
      setAssinado(true);
    } catch(e) { message.error(e.response?.data?.erro || 'Erro ao assinar'); }
    finally { setAssinando(false); }
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spin size="large" /></div>;
  if (erro) return <div style={{ maxWidth: 500, margin: '60px auto', padding: 20 }}><Result status="error" title="Link inválido" subTitle={erro} /></div>;
  if (assinado) return (
    <div style={{ maxWidth: 500, margin: '60px auto', padding: 20 }}>
      <Result status="success" icon={<CheckCircleOutlined />} title="Proposta Assinada!"
        subTitle={`Obrigado, ${proposta?.assinatura_cliente_nome || nome}! Sua assinatura foi registrada com sucesso.`} />
    </div>
  );

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: 20 }}>
      <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap" rel="stylesheet" />
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <h2 style={{ color: '#0099FF' }}>Assinatura de Proposta</h2>
        <p style={{ color: '#888' }}>CELUM INSPEÇÕES TÉCNICAS E COMÉRCIO LTDA</p>
      </div>
      <Card size="small" style={{ marginBottom: 16 }}>
        <p><strong>Proposta:</strong> {proposta?.numero} | Rev. {proposta?.versao}</p>
        <p><strong>Cliente:</strong> {proposta?.razao_faturamento || proposta?.razao_social || proposta?.nome_cliente}</p>
        <p><strong>Valor Total:</strong> R$ {parseFloat(proposta?.valor_total||0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
      </Card>
      <Card size="small" style={{ marginBottom: 16 }}>
<p style={{ marginBottom: 8 }}><strong>Nome completo do signatário:</strong></p>
        <input placeholder="Digite seu nome completo" value={nome} onChange={e => setNome(e.target.value)} autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" style={{ width: "100%", padding: "10px 14px", fontSize: 16, border: "1px solid #d9d9d9", borderRadius: 6, outline: "none" }} />
      </Card>
      <Card size="small" style={{ marginBottom: 16 }}>

        {modo === 'digitar' ? (
          <div>
            {nome && (
              <div style={{ border: '2px solid #0099FF', borderRadius: 8, backgroundColor: '#fff', padding: 20, textAlign: 'center' }}>
                <span style={{ fontFamily: 'Dancing Script, cursive', fontSize: 36, color: '#000' }}>{nome}</span>
              </div>
            )}
          </div>
        ) : (
          <div>
            <div style={{ border: '2px solid #0099FF', borderRadius: 8, backgroundColor: '#fff', marginBottom: 8 }}>
              <canvas ref={canvasRef} style={{ width: '100%', height: 200, display: 'block', touchAction: 'none' }} />
            </div>
            <Button size="small" onClick={() => padRef.current?.clear()}>Limpar</Button>
          </div>
        )}
      </Card>
      <p style={{ fontSize: 11, color: '#888', marginBottom: 16 }}>
        Ao assinar, você declara estar de acordo com todos os termos da proposta técnica e comercial nº {proposta?.numero}.
      </p>
      <Button type="primary" size="large" block icon={<EditOutlined />} onClick={assinar} loading={assinando}>
        Assinar Proposta
      </Button>
    </div>
  );
}
